import { computed, makeObservable } from "mobx";

import LicenseGroup from "./LicenseGroup";
import License from "./License";

const licensesIds = {
  unlimited_boards_license: 558,
  unlimited_contacts_license: 560,
};

/** Функция для обработки списка лицензий */
const prepareLicenses = (data, filterFunction, separateDates = true) => {
  const result = new LicenseGroup({ separateDates });

  if (data) {
    const services = data.services;

    services.forEach((license) => {
      if (filterFunction(license)) {
        result.list.push(new License(license));
      }
    });

    if (!separateDates && result.list.length) {
      result.endDate = result.list[0].endDate;
      result.remainingDays = result.list[0].remainingDays;
    }
  }

  return result;
};

/** Функция для определения является ли лицензия безлимитной */
const isUnlimitedLicense = (serviceId) =>
  serviceId === licensesIds.unlimited_boards_license ||
  serviceId === licensesIds.unlimited_contacts_license;

class PayedServices {
  profile;

  constructor(profile) {
    this.profile = profile;

    makeObservable(this, {
      unlimited: computed,
      trial: computed,
      regular: computed,
      payedServices: computed,
      profileDropdownLicenses: computed,
    });
  }

  get payedServices() {
    return this.profile.user.payed_services;
  }

  get profileDropdownLicenses() {
    const result = new LicenseGroup({ separateDates: false });

    if (!this.regular.isEmpty) {
      result.list = [].concat(this.regular.list, this.trial.list);
      result.endDate = this.regular.endDate;
      result.remainingDays = this.regular.remainingDays;
    }

    return result;
  }

  get regular() {
    return prepareLicenses(
      this.payedServices,
      (license) =>
        !license.is_dependent &&
        !license.irregular &&
        !license.is_trial &&
        !isUnlimitedLicense(license.service_id),
      false
    );
  }

  get trial() {
    return prepareLicenses(
      this.payedServices,
      (license) =>
        !license.is_dependent &&
        !license.irregular &&
        license.is_trial &&
        !isUnlimitedLicense(license.service_id),
      true
    );
  }

  get unlimited() {
    return prepareLicenses(
      this.payedServices,
      (license) => isUnlimitedLicense(license.service_id),
      true
    );
  }

  checkForLicense(licenseId) {
    const licenses = this.payedServices ? this.payedServices.services : null;

    if (licenses) {
      return licenses.find((license) => license.service_id === licenseId);
    }

    return false;
  }
}

export default PayedServices;
